export const environment = {
  production: true,
  apiBaseUrl: 'http://172.17.56.36:3000',
  endpoints: {
    login: '/auth/login',
    me: '/user/me',
    forgot: '/auth/forgot-password',
    reset: '/auth/reset-password',
  },
  tokenKey: 'smartlab_admin_access_token'
} as const;
